import React from "react";

interface EmptyMediaHolderProps {
  type: "image" | "video";
  onEdit?: () => void;
}

const EmptyMediaHolder: React.FC<EmptyMediaHolderProps> = ({ type, onEdit }) => {
  const icon = type === "image" ? "image" : "videocam";
  const label = type === "image" ? "No Image Provided" : "No Video Provided";

  return (
    <div
      className="flex w-full flex-col items-center justify-center gap-4 rounded-xl border-2 border-dashed border-theme-border bg-theme-background/40 py-16 px-6 transition-all hover:bg-theme-background/60 hover:border-brand-primary-light/40 group cursor-pointer"
      onClick={onEdit}
    >
      <div className="relative flex h-20 w-20 items-center justify-center rounded-full bg-theme-surface border border-theme-border shadow-sm group-hover:shadow-md group-hover:bg-theme-background transition-all">
        <span className="material-icons-outlined text-4xl text-theme-fg-muted group-hover:text-brand-primary">
          {icon}
        </span>
        <div className="absolute -bottom-1 -right-1 flex h-8 w-8 items-center justify-center rounded-full bg-brand-primary text-white shadow-sm ring-4 ring-theme-background">
          <span className="material-icons text-lg">add</span>
        </div>
      </div>
      <div className="text-center">
        <p className="text-base font-semibold text-theme-fg">{label}</p>
        <p className="mt-1 text-sm text-theme-fg-muted">
          Add media to this post to preview how it will look on social media.
        </p>
      </div>
      <button
        type="button"
        className="mt-2 rounded-lg bg-theme-surface border border-theme-border px-4 py-2 text-sm font-semibold text-theme-fg shadow-sm transition-all hover:bg-theme-secondary/10 group-hover:border-brand-primary/30"
        onClick={(e) => {
          e.stopPropagation();
          onEdit?.();
        }}
      >
        Upload {type}
      </button>
    </div>
  );
};

export default EmptyMediaHolder;
